<template>
<div class="container-fluid" >

 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i class="fa fa-database mr-2" aria-hidden="true"></i>VALORIZZAZIONE STOCK FORNITORE</h4>
  </div> 

 <div style="color:black" class="card-body"> 
  
  <div class="row">
  <div class="col-6"> 

  <div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong>
  </div>
  <div class="card-body text-dark">

  <form  v-on:submit.prevent="submit()">

    <div class="">
      
        <div class="form-group">           
           <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>            
        </div>
        <supplier-brand-list :key="refreshBrand"  v-bind:props="brand" @update="setBrandId"></supplier-brand-list>
        <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>         
        <div class="form-group">  
          <line-select :key="refreshLine" v-bind:optionBase="true"  v-bind:supplierId="supplier.Id" v-bind:isActive="items.length==0" @update="setLineId"></line-select>
        </div>
          
        <div class="form-group">           
           <season-select v-bind:props="season"  @update="setSeasonId"></season-select>            
        </div> 
             
        <div class="form-group">
           <year-select  v-bind:props="season_year" @update="setYear"></year-select>       
        </div>  
        
         <div class="form-group">               
          <department-select v-bind:props="department" @update="setDepartmentId"></department-select>            
        </div>
        <store-select v-bind:props="store"  @update="setStoreId"></store-select>
     
    </div>  
    <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
    <div v-if="progress>0 && type=='pdf'" class="progress mb-2 mt-2">
        <div class="progress-bar progress-bar-striped" role="progressbar"  :style="{'width':getProgress}">
          {{ progress }}%
        </div>
    </div>
    
    <div class="card-footer bg-transparent border-info">    
    
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="pdf" v-model="type">
    <label class="form-check-label" for="inlineRadio1">     
      <strong>ESPORTA IN PDF</strong></label>
      <i style="color:red;font-size: 25px" class="fas fa-file-pdf ml-2 mr-2" aria-hidden="true"></i>
  </div>
  <div class="form-check form-check-inline ">
    <input class="form-check-input " type="radio" name="inlineRadioOptions" id="inlineRadio2" value="csv" v-model="type">
    <label class="form-check-label" for="inlineRadio2">
      <strong>ESPORTA IN CSV</strong>
      <i style="color:blueviolet;font-size: 25px" class="fas fa-file-export ml-2 mr-2" aria-hidden="true"></i>
    </label>
  </div>
  <div class="form-group form-check mt-2">
    <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="showNegativeStock">
    <label class="form-check-label" for="exampleCheck1"><strong>MOSTRA SOLTANTO STOCK NEGATIVO</strong></label>
  </div>
      

    <button :disabled="spinner" type="submit"  class="btn btn-primary float-right">
    <i class="far fa-play-circle mr-2"></i>
      ESEGUI  
      <span v-if="spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button> 

     
    <!--
    <button @click="items=[],row_total=[]" type="button"   class="btn btn-outline-secondary">
       <i class="fas fa-redo-alt mr-2"></i>
      
        RESET
    </button>   
  -->
</div>

  </form>
  </div>
  </div>
  </div>


</div>

</div>

</div>
  
</div>

 
</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import categoryGrouping  from '@/components/common/CategoryGroupingSelect_1.vue'
import productStock      from '@/components/common/ProductStock.vue'
import lineSelect        from '@/components/common/LineSelect.vue'
import storeSelect       from '@/components/common/StoreSelect_1.vue'
import jsPDF             from 'jspdf'
import fmt               from '@/components/mixins/fmt.js'
import supplierBrandList from '@/components/common/SupplierBrandSelect_1.vue'


export default {
  mixins:[fmt],
  components: {alertBox,supplierSelect,seasonSelect,yearSelect,departmentSelect,categoryGrouping,productStock,lineSelect,storeSelect,supplierBrandList},
  data() {
    return {
      showNegativeStock : false,
      type            : 'pdf',
      progress        : 0,  
      pdf_title       :{ department : 'TUTTI I REPARTI',year:''},  
      store             : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false
      },
      supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      brand           :
      {
        supplierId    : 0,
        Id            : '%',
        required      : false,
        allBrands     : true

      },  
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        type          : true

      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : true,
       
      },
      catGrouping     : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },


      isOpen          : [], 
      component       : '', 
             
      lineId          : 0,
            
      spinner1        : false,
      spinner         : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
          
      items           : [],
      //detail          : [], 
      cols            : [],
      rows            : [],
      componentKey    : 0,
      refreshLine     : 0,
    
      refreshBrand    : 1
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
    getProgress()
    {
      let p = this.progress
      return p + "%";
    }
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {
    
    this.setGroupCategoryId(0)
    this.setDepartmentId(0)
    this.setYear(0)
  },
  methods: {
    setStoreId(storeId,e)
    {      
      this.store.Id = storeId
      this.pdf_title.store = e.target.options[e.target.options.selectedIndex].text  
            
    },  
    setSupplierId(supplierId,text)
    { 
      

      this.supplier.Id = supplierId
      this.pdf_title.supplier = text
      this.refreshLine++  
      this.brand.supplierId = supplierId
      this.refreshBrand++
    },
    setBrandId(brandId,e)
    {
      this.pdf_title.brand = e.target.options[e.target.options.selectedIndex].text  
      this.brand.Id = brandId
    },
    setSeasonId(seasonId,e)
    {           
      this.season.Id        = seasonId
      this.pdf_title.season = e.target.options[e.target.options.selectedIndex].text
    },
    setYear(year,e)
    {
      if(year>0)
      {
        this.season_year.year = year
        this.pdf_title.year   = e.target.options[e.target.options.selectedIndex].text
      }

    },
    setDepartmentId(departmentId,e)
    {
      if(departmentId > 0)
      {
        this.department.Id        = departmentId
        this.pdf_title.department = e.target.options[e.target.options.selectedIndex].text
      }
      else
      {
        this.pdf_title.department = ''
      }
    },
    setGroupCategoryId(Id,e)
    {
      if(Id>0)
      {
        this.catGrouping.Id = Id
        this.pdf_title.catGrouping = e.target.options[e.target.options.selectedIndex].text
      }
      else
      {
        
        this.pdf_title.catGrouping = ''
      }

    },      
      

    setLineId(lineId)
    {
      this.lineId = lineId
      
    },
    

    async export_data()
    { 
      const header = Object.keys(this.items[0]);     
          
            let row = '' 
            let csvContent = "data:text/csv;charset=utf-8," 


            for (let i = 0; i < header.length; i++) {
                row += header[i] + ";";
            }
            csvContent += row + "\r\n";

            this.items.forEach( (item) =>   {
                  
              row = ''
              for (let i = 0; i < header.length; i++) {
                  row += item[header[i]] + ";";
                }
  


                csvContent += row + "\r\n";
                    

                  
            });
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", this.pdf_title.supplier +  "_valorizzazioneStock.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv".

         

          
          },



   

    submit() 
    {
      this.getData(this.type)
    },  
    
      
    
    async getData(type) {
      
      this.isOpen = []
      this.cols   = []
      this.rows   = []
      
      this.items  = []
      
      this.msg.title = ''
      const sp         =  {'sp' : type == 'pdf' ? 'spProductColorStockSupplierNewPdf' : 'spProductColorStockSupplierCSV'}      
      const data       = {

        'companyId'    : this.company.Id,
        'supplierId'   : this.supplier.Id,
        'seasonId'     : this.season.Id,
        'departmentId' : this.department.Id,
        'categoryId'   : this.catGrouping.Id,
        'season_year'  : this.season_year.year,
        'lineId'       : this.lineId,
       
        'storeId'      : this.store.Id,
        'brandId'      : this.brand.Id,  
        'showNegativeStock' : this.showNegativeStock ? 1 : 0

      }

      //console.log(data)
      
      const json  = Object.assign(data, sp)      
      
      this.spinner = true

      await api.post(json).then(res => {
         
          if(res.status==200)
            {
              
            this.items = res.data.recordsets[0]
            if(this.items.length == 0)
              {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
                return
              }
              if(type == 'pdf')
              {
                //this.printPDF()  
                this.exportToPDF()
              }
              else
              {
                this.export_data()
              }  

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      

    },
    async exportToPDF()
    {
             
     let grandTotal1 = 0
     let grandTotal2 = 0
   
     const detail = this.items

     const wait =  (ms) =>
      {
          return new Promise(resolve => {
          setTimeout(() => { resolve('') },ms);
          })
      }
    
     let r = 0

 
      const doc = new jsPDF({orientation: "landscape" })
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()
        doc.setFont('helvetica', 'italic')
        doc.setFontSize(8)
      
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          if(i == 1)
          {
            header()
            descriptionHeader()
          }
          timeStamp()
          doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 270,205, {
          align: 'center'})
        }
      }

      const timeStamp = () =>
      {
        const d = new Date();
        const n = d.toLocaleDateString();
        const t = d.toLocaleTimeString();
        doc.setFontSize(7)
        doc.setTextColor(0, 0, 0)  
        doc.setFont("helvetica",'italic')
        doc.text( n + ' ' + t,  15, 205,null,null,'left');
        doc.setFont("helvetica",'normal')
      }

      const header = () =>{

        
            doc.setDrawColor(0)
            doc.setFillColor(0,0,153)
            doc.roundedRect(3, 4, 292, 5,1,1,'FD')      


            doc.setFontSize(10)
            doc.setFont("helvetica",'bold')
            doc.setTextColor(255, 255, 255)  
            doc.text('VALORIZZAZIONE STOCK ' + this.pdf_title.supplier    , 150, 7.5,null,null,'center');
            doc.setTextColor(0, 0, 0)  
            
            doc.setFontSize(7)
            doc.setFont("helvetica",'italic')
            //doc.text( 'Tipo raggruppamento ' + this.grouping[this.group_by].group_by,  150, 10.5,null,null,'right');
            doc.setFont("helvetica",'normal')


      }

      const descriptionHeader = () =>
      {

          const col1 = 11
          const col2 = 33
          const col3 = 105
          //const col4 = 156
          const col5 = 156
          const col6 = 231
          const col7 = 257

          doc.setFontSize(6)
          doc.setFont("helvetica",'bold')
          const row = 13
          
      //    doc.text('PROG. GRUPPO'  ,6,row)
          doc.text('ID PRODOTTO'  ,col1,row)
          doc.text('CODICE PRODOTTO'  ,col2,row)
          doc.text('BRAND'  ,col3,row)
         // doc.text('LINEA'  ,col4,row)
          doc.text('GRUPPO/CATEGORIA'  ,col5,row)
          doc.text("IN STOCK "  ,col6,row)
          doc.text("VALORE STOCK €"  ,col7,row)
          doc.setFont("helvetica",'normal')
            
      }

      

        const productRow = (item,row) => {

          const col1 = 11
          const col2 = 32
          const col3 = 104
          //const col4 = 154
          const col5 = 155
          const col6 = 230
          const col7 = 256


        doc.setFont("helvetica", "bold")        
        
        doc.setDrawColor(0)
        doc.setFillColor(224,224,224)
        
        //doc.roundedRect(5, row - 1, 20, 7,1,1,'FD')              
      
        doc.roundedRect(col1, row - 1, 20, 7,1,1,'FD') 
        doc.roundedRect(col2, row - 1, 70, 7,1,1,'FD') 
        doc.roundedRect(col3, row - 1, 50, 7,1,1,'FD') 
        //doc.roundedRect(col4, row - 1, 50, 7,1,1,'FD') 
        doc.roundedRect(col5, row - 1, 70, 7,1,1,'FD') 
        doc.roundedRect(col6, row - 1, 20, 7,1,1,'FD')  
        doc.roundedRect(col7, row - 1, 35, 7,1,1,'FD')  
        doc.setFontSize(11)
        
        const rowItem = row + 3  
               
        doc.setFont("helvetica", "normal") 
        doc.setFontSize(7)
        doc.text( String(item.row_Number)  ,6,rowItem)   
        doc.setFontSize(11)    
        doc.setFont("helvetica", "bold") 
        doc.text( item.productId.toString() ,12,rowItem)
        doc.text( item.sku ,33,rowItem)
        doc.setFontSize(6)
        doc.setFont("helvetica", "italic")        
        doc.text( item.season + ' ' + String(item.season_year) + ' ' + item.department ,33,rowItem + 2.5)
        doc.setFont("helvetica", "bold") 
        doc.setFontSize(11)     
        doc.text( item.brand ,105,rowItem )
        doc.setFontSize(6)
        doc.setFont("helvetica", "italic")        
        doc.text( item.line ,105,rowItem + 2.5)
        doc.setFont("helvetica", "bold") 
        doc.setFontSize(11)     
        doc.text( item.cat_grouping + ' ' +  item.category ,158,rowItem )
        
        doc.setFontSize(6)
        doc.setFont("helvetica", "italic")        
        doc.text( item.description ,158,rowItem + 2.5 )
        doc.setFont("helvetica", "bold") 
        doc.setFontSize(11)   
        doc.setTextColor(0, 128, 0) 
        doc.text(String(item.qty) ,col6 + 18,rowItem,null,null,'right'  )

        doc.text('€ ' + this.fmt1(item.total) ,col7 + 33,rowItem,null,null,'right' )
        doc.setTextColor(0, 0, 0) 
                
      }

      const rowSizeHeader = (sizes,row) =>{

       
        let col = 110
        for (var i = 0; i < sizes.length; i += 1) 
        {

          doc.setDrawColor(0)
          //doc.setFillColor(240,240,240)
          doc.setFillColor(102,255,253)  
          doc.rect(col, row , 10, 6,'FD');
          doc.setFontSize(6.5)
          doc.setFont("helvetica",'bold')
          doc.text(sizes[i],col + 5,row + 3.5,null,null,'center')
          doc.setFontSize(8)
          //doc.setFont("helvetica",'bold')
          col += 10

        }
        return sizes 
      }

      const colorSizes = (item,sizes,row,header) => {
          
        

          let col = 110
          const itemRow = row

          const col1 = 18
          const col2 = 55
          const col3 = 100

          if(item.store)
          {
            doc.setDrawColor(0)  
            doc.setFillColor(230, 238, 255)  
            doc.rect(col1, itemRow, 35, 6,'FD');
          }
         

          doc.rect(col2, itemRow, 40, 6)  

          // ITEM TOTAL
          doc.setDrawColor(0)            
          doc.setFillColor(204, 255, 242)  
          doc.rect(col3 , itemRow, 10, 6,'FD') 
          
          // STORE
          doc.text(item.store.toString() ,col1+3,itemRow + 4)

          // COLOR 
          doc.setFontSize(7)
          doc.text(item.color.toString() ,col2+3,itemRow + 2.5)
          doc.text(item.supplierColor ,col2+3,itemRow + 5)
          doc.setFontSize(8)

          
          let total = 0
                    
          header.forEach(size => {
              sizes.findIndex(item =>{
              if(size == item.size )
              {
               
                doc.rect(col, row, 10, 6)        
                doc.text(item.qty.toString().substr(0,10) , col + 2 , itemRow + 4 )
                total += item.qty
                
              }
              
            })
            col += 10    
          })

          doc.setTextColor(0,0,0) 
          doc.text(total.toString() ,col3+9,itemRow + 4,null,null,'right')
          doc.setTextColor(0, 0, 0) 
          

      }      

      
      
      let firstRow   = 15
      const lastRow  = 185

      const  createCard  = (product,body,sizes,row)  => 
      {                
        
        let rowCard = row
        if(rowCard > lastRow)
        {
         
          doc.addPage()
          
          rowCard = firstRow
         
        }
        
        productRow(product,rowCard)        
        rowCard = rowCard + 7.5
        
        if(rowCard > lastRow)
        {
          
          doc.addPage()
          
          rowCard = firstRow
        }
        
       
          /*      
          rowCard = rowCard + 1
          PerfomanceHeader(rowCard)
          rowCard = rowCard + 3
          productRowPerformance(product.productId,rowCard)
          rowCard = rowCard + 2
          */
          
        
        
        const header = rowSizeHeader(sizes,rowCard)        
        rowCard = rowCard + 6

          if(rowCard > lastRow)
          {
            doc.addPage()
            rowCard = firstRow
          }
        /*
          if(rowCard > lastRow)
          {
            doc.addPage()
            rowCard = firstRow
          } 
          */

          
          const data = JSON.parse(body.data)          
          let h = 0
          data.forEach(item => {   
            
            let store = item.store           
            const colors = item.c                           
            colors.forEach( item => {

                const color = item.color
                const supplierColor = item.supplierColor
                const sizes = item.s
                const data = {}
                data.store = h > 0 ? '' : store
                data.color = color
                data.supplierColor = supplierColor
                if(rowCard > lastRow)
                {
                  doc.addPage()
                  rowCard = firstRow
                }

                colorSizes(data,sizes,rowCard,header)                 
                rowCard = rowCard + 6
                h++  
            })
            h = 0
            
            })

        return rowCard
      }
      
            
      let row = firstRow
      let row_count = 0
      let j 
      for (j = 0; j < detail.length; j++) 
      
      {
          const item = detail[j]
                  
          r++  
          this.progress = Math.round(r / detail.length * 100)
          await wait(0)   
          

          if(item.productId)
          {
            grandTotal1 += item.qty
            grandTotal2 += item.total
                        
            const data   = item
            const header = data.header.split('|')
            
            row_count    = createCard(item,data,header,row)                 
           
            row          = row_count + 4
          }  


      }
      r = 0
      this.progress = Math.round(r / detail.length * 100)
      

  
      const addLastPage = (grandTotal1,grandTotal2) =>{

        doc.addPage()

          header()
          const add = 7
          doc.setFontSize(14)
          doc.setTextColor(0, 0, 0)  
          
          doc.text('TOTALE ARTICOLI IN STOCK   ' + String(grandTotal1)  ,15,10 + add)
          doc.text('VALORE ARTICOLI IN STOCK € ' + this.fmt1(grandTotal2) ,15,16 + add)
              
          
             
            
        }
     


      addLastPage(grandTotal1,grandTotal2)
      addFooters(doc)
      window.open(URL.createObjectURL(doc.output("blob")))

      
      
      
    }





  },




   


};
</script>
<style scoped>


.my-custom-scrollbar {
position: relative;
height: 700px;
overflow: auto;
}
.pointer:hover
{
  _background-color: white;
  
  cursor: pointer;
}

.detail tr:nth-child(1) th  {
    background   : yellow;
}
.master tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : #FFFFE0;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }

 .tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }
.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
</style>